import { useState } from "react";

interface IProps {
  name: string;
  error?: string;
  onSubmit: (password: string, confirmPassword: string) => void;
}

export function PasswordScreen(props: IProps) {
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [localError, setLocalError] = useState<string>("");

  const onClick = () => {
    const err = (() => {
      if (!password || password.length < 4) return "Пожалуйста, введите пароль (минимум 4 символа).";
      if (password !== confirmPassword) return "Пароли не совпадают.";
      return "";
    })();
    setLocalError(err);
    if (!err) props.onSubmit(password, confirmPassword);
  };

  return (
    <>
      <div className="RegistrationConteinerText">
        <div className="textConteiner">
          <h1 className="registrationFinalTitle">Добро пожаловать, {props.name}! </h1>
          <p className="registrationConteinerText-text">
            Остался последний шаг: задайте пароль для входа.
          </p>

          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setLocalError("");
            }}
            placeholder="Пароль"
            required
            autoFocus
            onKeyUp={(e) => {
              if (e.code === "Enter") onClick();
            }}
          />

          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setLocalError("");
            }}
            placeholder="Подтверждение пароля"
            required
            onKeyUp={(e) => {
              if (e.code === "Enter") onClick();
            }}
          />

          {(props.error || localError) && (
            <p className="error-message">{props.error || localError}</p>
          )}
        </div>
      </div>

      <div className="registration-button" onClick={onClick}>
        Сохранить пароль
      </div>
    </>
  );
}

